import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import HomeIcon from './icons/HomeIcon';
import ChevronRightIcon from './icons/ChevronRightIcon';

const homeTextBaseClass =
  'text-sm font-medium text-gray-500 hover:text-gray-700';

export default function Breadcrumbs({
  breadcrumbs: { pages, homeUrl, homeTitle, onClick = () => {} },
  className,
  dataTestId
}) {
  const showHomeText = (homeTitle || '').length > 0;  
  return (
    (<nav
      data-testid={dataTestId}
      className={classnames('flex mb-4', className)}
      aria-label="Breadcrumb">
      <ol
        data-testid="ol-a1cc14db"
        role="list"
        className="flex items-center space-x-4">
        <li data-testid="li-91f94b62">
          <div data-testid="div-b6a3d5dd">
            <Link
              data-testid="breadcrumbHome"
              to={homeUrl || '/'}
              className="text-gray-400 hover:text-gray-500"
              onClick={() => onClick(homeUrl || '/', homeTitle)}
            >
              <div data-testid="div-8cbe76f3" className="flex items-center space-x-1">
                <HomeIcon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
                {showHomeText && (
                  <span data-testid="span-52f60525" className={homeTextBaseClass}>{homeTitle}</span>
                )}
              </div>
              <span data-testid="span-a168c26c" className="sr-only">Home</span>
            </Link>
          </div>
        </li>
        {pages.map((page, index) => (<li data-testid={`li-9f2091d6-${index}`} key={page.name}>
          <div data-testid={`div-01af51a5-${index}`} className="flex items-center">
            <ChevronRightIcon
              className="h-5 w-5 flex-shrink-0 text-gray-400"
              aria-hidden="true"
            />
            {page.render && (
              <div
                data-testid={`div-f1606a65-${index}`}
                className={classnames(homeTextBaseClass, 'ml-4')}>
                {page.render()}
              </div>
            )}
            {!page.render && page.current && (
              <span
                data-testid="breadcrumbLinkCurrent"
                className={classnames(homeTextBaseClass, 'ml-4')}
              >
                {page.name}
              </span>
            )}
            {!page.render && !page.current && (
              <Link
                data-testid="breadcrumbLink"
                to={page.href}
                className={classnames(homeTextBaseClass, 'ml-4')}
                aria-current={page.current ? 'page' : undefined}
                onClick={() => onClick(page.href, page.name)}
              >
                {page.name}
              </Link>
            )}
          </div>
        </li>))}
      </ol>
    </nav>)
  );
}

Breadcrumbs.propTypes = {
  homeTitle: PropTypes.string,
  homeUrl: PropTypes.string,
  pages: PropTypes.array,
};

Breadcrumbs.defaultProps = {
  homeUrl: '/',
  homeTitle: '',
  pages: [],
};
